// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeaderPart_wrapper__8t5Rq","pageHeader":"PageHeaderPart_pageHeader__QueIG","providerSubPage":"PageHeaderPart_providerSubPage__cGEhL"};